export const ENTITY_JURISDICTIONS_RESET = 'ENTITY_JURISDICTIONS_RESET';
